import React from 'react';
import styled from 'styled-components';
import dark from 'prism-react-renderer/themes/nightOwl';
import light from 'prism-react-renderer/themes/nightOwlLight';
import Highlight, { defaultProps } from 'prism-react-renderer';
import { useTheme } from '../theme/theme-context';
import { borderRadius } from '../theme/border-radius';
import { shadow } from '../theme/shadow';
import Button from '../button';
const StyledButton = styled(Button) `
  position: absolute;
  right: 16px;
  top: 16px;
  box-shadow: ${shadow.md};
`;
const Pre = styled.pre `
  text-align: left;
  margin: 1em 0;
  padding: 16px;
  overflow: scroll;
  font-family: 'SF Mono', Menlo, monospace;
  border-radius: ${borderRadius.md};
  position: relative;
`;
const Line = styled.div `
  display: table-row;
`;
const LineNo = styled.span `
  display: table-cell;
  text-align: right;
  padding-right: 1em;
  user-select: none;
  opacity: 0.5;
`;
const LineContent = styled.span `
  display: table-cell;
`;
export const CodeHighlight = (props) => {
    const { type } = useTheme();
    const theme = props.codeTheme ? props.codeTheme : type === 'light' ? light : dark;
    return (React.createElement(Highlight, Object.assign({ "data-role": "code-highlight" }, defaultProps, { theme: theme, code: props.code, language: props.language }), ({ className, style, tokens, getLineProps, getTokenProps }) => (React.createElement(Pre, { "data-role": "code-highlight-code", className: className, style: style },
        props.copyable && React.createElement(StyledButton, null, "COPY"),
        tokens.map((line, i) => (React.createElement(Line, Object.assign({ "data-role": "code-highlight-line", key: i }, getLineProps({ line, key: i })),
            props.showLine && React.createElement(LineNo, { "data-role": "code-highlight-line-number" }, i + 1),
            React.createElement(LineContent, { "data-role": "code-highlight-line-content" }, line.map((token, key) => (React.createElement("span", Object.assign({ key: key }, getTokenProps({ token, key })))))))))))));
};
